import { EnvironmentInjector, Injectable, Injector } from '@angular/core';
import { hintboxController, HintboxOptions, listAnimation } from '@inscomponents/core';
import { RoutingService } from '@skylab-angular-shared/core';
import { FrameworkDelegate } from './framework-delegate.service';
import { OverlayBaseController } from './overlay';

@Injectable({providedIn: 'root'})
export class HintboxController extends OverlayBaseController<HintboxOptions, HTMLInsHintboxPopupElement> {
    public constructor(
        private frameworkDelegate: FrameworkDelegate,
        private environmentInjector: EnvironmentInjector,
        private injector: Injector,
        private routingService: RoutingService
    ) {
        super(hintboxController);
        this.init();
    }

    private init() {
        this.routingService.states$.subscribe(async _ => {
            const top = await this.ctrl.getTop();
            top?.dismiss();
        });
    }

    public override create(opts: HintboxOptions): Promise<HTMLInsHintboxPopupElement> {
        const config = {
            enterAnimation: listAnimation.enterAnimation,
            leaveAnimation: listAnimation.leaveAnimation,
            ...opts,
        };

        return super.create({
            ...config,
            delegate: this.frameworkDelegate.create(this.environmentInjector, this.injector),
        });
    }
}
